import './InvitesTabStyle.css';

import SubTabSection from '../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabSection';
import SubTabParent from '../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabParent';
import { useEffect, useState } from 'react';
import { collection, deleteDoc, doc, getDocs, orderBy, query, setDoc, where } from 'firebase/firestore';
import { db } from '../../../../_shoru_shared_library/firebase/firebase_setup';
import SectionLoader from '../../../../_shoru_shared_library/loaders/SectionLoader';
import SubTabNoData from '../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabNoData';
import { CheckBoxOutlineBlank, CopyAll, DeleteOutline } from '@mui/icons-material';
import FormSelect from '../../../../_shoru_shared_library/components/form/FormSelect';
import FormInput from '../../../../_shoru_shared_library/components/form/FormInput';


function InvitesTab(props) {

  const [invites, setInvites] = useState(null);
  const [open, setOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const userData = props.userData;
  const seasons = props.organisationData.seasons;

  const refreshList = () => {
    setRefreshKey((prev) => prev + 1);
  }

  useEffect(() => {
    async function getInvites() {
      setInvites(null);
      const q = query(
        collection(db, userData.active_organisation_id, 'project-data', 'active-invites'),
        where('type', '==', 'project'),
        orderBy("week", "asc")
      );
      const snaps = await getDocs(q);
      const docs = snaps.docs.map((d) => d.data());
      setInvites(docs);
    }
    getInvites();
  }, [refreshKey]);

  const handleDelete = async(uid) => {
    const inviteDoc = doc(db, userData.active_organisation_id, 'project-data', 'active-invites', uid);
    try {
      await deleteDoc(inviteDoc);
      refreshList();
    }
    catch(err) {
      console.error(err);
      alert('Coult not delete invite. Please try again.');
    }
  }

  const handleCopy = async(uid) => {
    try {
      await navigator.clipboard.writeText(`https://casting.shoru.app/invite/${userData.active_organisation_id}/${uid}`);
      alert('Invite link copied to clipboard');
    }
    catch(err) {
      console.error('Failed to copy: ', err);
      alert('Failed to copy invite link');
    }
  };

  const handleCopyAll = async(created=null) => {
    console.log("CREATED:", created);
    let target = created ? created : invites;
    console.log("TARGET:", target);
    try {
      const sorted = target.sort((a, b) => {
        if(a.season !== b.season) {
          return a.season.localeCompare(b.season);
        }
        if (a.week !== b.week) {
          return a.week - b.week;
        }
        return a.project_type.localeCompare(b.project_type);
      });

      let copyString = '';
      let lastSeason = null;
      sorted.forEach((c, i) => {
        if(c.season !== lastSeason) {
          seasons.forEach((s) => {
            if(s.uid === c.season) copyString += `${i===0 ? '' : '\n\n'}${s.name.toUpperCase()}:\n\n`
          })
          lastSeason = c.season;
        }
        copyString += `Week ${c.week} ${c.project_type}:\nhttps://casting.shoru.app/invite/${userData.active_organisation_id}/${c.uid}${i===target.length-1 ? '' : '\n\n'}`;
      })

      await navigator.clipboard.writeText(copyString);
      alert('Invite links copied to clipboard');
    }
    catch(err) {
      console.error('Failed to copy: ', err);
      alert('Failed to copy invite links');
    }
  };

  if(invites === null) return <SectionLoader />

  return (
    <SubTabParent passData={props}>

      {
        open 
        ? <CreateInviteMenu 
            seasons={seasons} 
            userData={userData}
            setOpen={setOpen} 
            refreshList={refreshList} 
            accentColour={props.accentColour}
            handleCopyAll={handleCopyAll}
          />
        : <div />
      }

      <SubTabSection no_background>
        <div className='create-invite'>
          <button style={{backgroundColor: props.accentColour, width: '100%'}} onClick={() => setOpen(true)}>Create Invites</button>
        </div>
      </SubTabSection>

      {
        invites.length 
        ? <SubTabSection title='Active Invites' description='These invites are yet to be accepted.'>
            <div className='invite-list-copy-all'>
              <button onClick={() => handleCopyAll(null)}><CopyAll/> Copy All</button>
            </div>
            <InviteList 
              invites={invites} 
              seasons={seasons} 
              handleDelete={handleDelete}
              handleCopy={handleCopy}
            />
          </SubTabSection>
        : <SubTabNoData title='No Pending Invites' description='' icon={<CheckBoxOutlineBlank />} />
      }
    </SubTabParent>
  )

}

export default InvitesTab;



function InviteList({invites, seasons, handleDelete, handleCopy}) {

  const sorted = invites.sort((a, b) => {
    if (a.week !== b.week) {
      return a.week - b.week;
    }
    return a.project_type.localeCompare(b.project_type);
  });

  return (
    <div className='invite-list'>
      {
        sorted.map((i) => {

          let season;
          seasons.forEach((s) => {
            if(s.uid === i.season) season = s.name;
          })

          return (
            <div key={i.uid} className='invite-list-item'>
              <div className='invite-list-name'>
                <div>Week {i.week} {i.project_type}</div>
                <div>{season}</div>
              </div>
              <div>
                <CopyAll onClick={() => handleCopy(i.uid)} className='copy-invite' />
                <DeleteOutline onClick={() => handleDelete(i.uid)} className='delete-invite' />
              </div>
            </div>
          )

        }
        )
      }
    </div>
  )

}


function CreateInviteMenu({seasons, userData, setOpen, refreshList, accentColour, handleCopyAll}) {

  const activeSeasons = seasons.filter((x) => x.active);

  if(activeSeasons.length === 0) {
    alert('You must have an active season to create invites');
    setOpen(false);
  }

  const [season, setSeason] = useState(activeSeasons[0].uid);
  const [week, setWeek] = useState(0);
  const [showType, setShowType] = useState('');

  const [isCreating, setIsCreating] = useState(false);
  const [created, setCreated] = useState([]);

  const handleClose = () => {
    refreshList();
    setOpen(false);
  }

  const handleCreate = async() => {
    setIsCreating(true);

    if(!season || !showType || !week === '') {
      alert('Please fill out all required fields');
      setIsCreating(false);
      return;
    }

    if(week < 0) {
      alert('Week must be positive');
      setIsCreating(false);
      return;
    }

    const invite = {
      uid: Math.floor(1000000000 + Math.random() * 9000000000).toString(),
      type: 'project',
      week: week,
      project_type: showType,
      season: season,
    }

    try {
      const inviteDoc = doc(db, userData.active_organisation_id, 'project-data', 'active-invites', invite.uid);
      await setDoc(inviteDoc, invite);
      setCreated((prev) => [...prev, invite]);
    }
    catch(err) {
      alert('Could not create invite, please try again');
      console.error(err);
    }
    finally {
      setIsCreating(false);
    }
  }

  return (
    <div className='create-invite-container'>
      <div className='create-invite-background' onClick={handleClose}>
        <div className='create-invite-menu' onClick={(e) => e.stopPropagation()}>
          <h2>Create Invite</h2>
          <div className='create-invite-form'>
            <FormSelect required title='Season' value={season} setValue={setSeason} disabled={isCreating}>
              {
                activeSeasons.map((s) => <option value={s.uid}>{s.name}</option>)
              }
            </FormSelect>
            <FormInput required title='Week' value={week} setValue={setWeek} type='number' disabled={isCreating} />
            <FormInput required title='Show Type' value={showType} setValue={setShowType} placeholder='e.g. ODN / Weekend Show / Fringe Show' disabled={isCreating} />
            <p className='create-invite-disclaimer'>Show names and account details are provided when invites are accepted</p>
            <button style={{backgroundColor: accentColour, width: '100%'}} onClick={handleCreate}>Create Invite</button>
            {
              created.length
              ? <div className='created-invites-list'>
                  <div className='created-invites-header'>Created Invites</div>
                  <div className='created-invites-copy-all' onClick={() => handleCopyAll(created)}><CopyAll /> Copy All</div>
                  {
                    created.map((i) => {
                      let season;
                      seasons.forEach((s) => {
                        if(s.uid === i.season) season = s.name
                      });

                      return (
                        <div key={i.uid} className='created-invites-item'>
                          <div>{season} - Week {i.week} {i.project_type}</div>
                          <a className='created-invite-link' href={`https://casting.shoru.app/invite/${userData.active_organisation_id}/${i.uid}`} target='_blank'>https://casting.shoru.app/invite/{userData.active_organisation_id}/{i.uid}</a>
                        </div>
                      )
                    })
                  }
                </div>
              : <div />
            }
          </div>
        </div>
      </div>
    </div>
  )
}